/* GN — Homepage (FIX 28sept): scroll-animaties, carrousel-knoppen, optellende cijfers */
(function () {
  'use strict';
  if (window.__gnHome) return;
  window.__gnHome = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal() {
    var els = document.querySelectorAll('.gnh-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
        var n = e.target.querySelector('[data-gnh-count]');
        if (n) count(n);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  function count(el) {
    var raw = el.getAttribute('data-gnh-count') || '';
    var m = raw.match(/^(\D*)([\d.,]+)(.*)$/);
    if (!m || reduce) return;
    var pre = m[1], num = m[2], post = m[3];
    var comma = num.indexOf(',') > -1;
    var clean = num.replace(/\./g, '').replace(',', '.');
    var target = parseFloat(clean);
    if (isNaN(target)) return;
    var dec = comma ? (num.split(',')[1] || '').length : 0;
    var thousands = /\d\.\d{3}/.test(num);
    var start = null, dur = 1400;
    function fmt(v) {
      var s = v.toFixed(dec);
      if (comma) s = s.replace('.', ',');
      if (thousands) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return pre + s + post;
    }
    function step(t) {
      if (!start) start = t;
      var p = Math.min((t - start) / dur, 1);
      p = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(target * p);
      if (p < 1) requestAnimationFrame(step); else el.textContent = raw;
    }
    requestAnimationFrame(step);
  }

  function rails() {
    document.querySelectorAll('[data-gnh-rail]').forEach(function (root) {
      if (root.__gnh) return; root.__gnh = true;
      var track = root.querySelector('[data-gnh-track]');
      var prev = root.querySelector('[data-gnh-prev]');
      var next = root.querySelector('[data-gnh-next]');
      if (!track) return;
      function step() { var c = track.querySelector('.gnh-card'); return c ? c.getBoundingClientRect().width + 14 : track.clientWidth * 0.8; }
      function upd() {
        if (prev) prev.disabled = track.scrollLeft < 4;
        if (next) next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 4;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });
    document.querySelectorAll('.gnh-proof__stats').forEach(function (ul) { ul.style.setProperty('--n', ul.children.length); });
  }

  /* Thema-secties op de homepage (bestsellers, kruidenpotjes, blog) laten meebewegen */
  function themeSections() {
    if (!document.body || !document.body.classList.contains('template-index')) return;
    document.querySelectorAll('#content .shopify-section').forEach(function (sec) {
      if (sec.__gnhT || sec.querySelector('.gnh')) return; sec.__gnhT = true;
      sec.querySelectorAll('h2').forEach(function (h) { h.classList.add('gnh-reveal'); });
      sec.querySelectorAll('.l4cl').forEach(function (list) {
        var items = list.querySelectorAll(':scope > li');
        var slider = list.classList.contains('swiper-wrapper') || (items[0] && items[0].classList.contains('swiper-slide')) || list.closest('.swiper, .swiper-container, [class*="slider"]');
        if (slider) { list.classList.add('gnh-reveal'); return; }
        items.forEach(function (li, i) { li.classList.add('gnh-reveal'); li.style.setProperty('--d', ((i % 4) * 0.08) + 's'); });
      });
    });
  }

  /* Hero: rustige parallax op desktop */
  function parallax() {
    if (reduce || !window.matchMedia('(min-width: 761px)').matches) return;
    var hero = document.querySelector('.gnh-hero');
    var media = hero && hero.querySelector('.gnh-hero__media');
    if (!media || media.__gnhP) return; media.__gnhP = true;
    var ticking = false;
    function upd() {
      ticking = false;
      var r = hero.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      var y = Math.max(0, Math.min(-r.top, r.height)) * 0.035;
      media.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0) scale(1.08)';
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

  function init() { rails(); themeSections(); reveal(); parallax(); }
  /* Vangnet: toon alles na 2,5 s, ook als de observer niet vuurt */
  setTimeout(function () { document.querySelectorAll('.gnh-reveal:not(.is-in)').forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < window.innerHeight) el.classList.add('is-in'); }); }, 2500);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { init(); });
})();
